<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">

          <div class="card-section-header-wrapper">
            <h3 class="card-section-header">
              <span class="mr-4"><i class="fas fa-list"></i> </span> Worker Sessions
            </h3>
            <button *ngIf="showExportButton" type="button" (click)="export();" class="btn color_blue-btn btn-round">
              <i class="fas fa-plus"></i>
              &nbsp;
              <strong>EXPORT CSV</strong>
            </button>
          </div>

          <div *ngIf="inProgress" class="row mb-3">
            <div class="col-md-12 d-flex justify-content-center">
              <div class="col-md-4 text-center">
                <span class="ui-widget">Downloading...</span>
                <p-progressBar
                  mode="determinate"
                  [ngClass]="progressValue > 55 ? 'text-white' : 'text-black'"
                  [value]="progressValue | number:'1.0-0'">
                </p-progressBar>
                <button type="button" class="btn btn-outline-secondary btn-sm mt-2 mb-2" (click)="cancelExport()">Cancel Export</button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12" *ngIf="!isSiteDelegateView">
              <a style="float: right;" [routerLink]="['/', routeRole, 'site-sessions']">Go to Site Sessions</a>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>From</label>
                <p-calendar class="form-control" [(ngModel)]="fromDate" (ngModelChange)="onFromDateChange($event)" dateFormat="dd/mm/yy" [disabled]="inProgress"></p-calendar>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>To</label>
                <p-calendar class="form-control" [(ngModel)]="toDate" (ngModelChange)="onToDateChange($event)" dateFormat="dd/mm/yy" [disabled]="inProgress"></p-calendar>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Session Type</label>
                <p-dropdown class="form-control" [(ngModel)]="selectedSessionType" [options]="sessionTypes" optionLabel="label" (onChange)="onSessionTypeChanged($event)" [disabled]="inProgress"></p-dropdown>
              </div>
            </div>
            <div class="col-md-4" *ngIf="sitesArray.length">
              <div class="form-group">
                <label>Site</label>
                <p-dropdown
                    class="form-control"
                    [(ngModel)]="selectedSite"
                    (ngModelChange)="onSelectedSiteChange($event)"
                    [options]="sitesArray"
                    optionLabel="label"
                    defaultLabel="Select Site"
                    filter="true"
                    [style]="{'width':'100%'}"
                    [disabled]="inProgress"
                ></p-dropdown>
              </div>
            </div>
            <div class="col-md-4" *ngIf="companiesArray.length && showContractors">
              <div class="form-group">
                <label>Contractor</label>
                <p-dropdown
                    class="form-control"
                    [(ngModel)]="selectedCompany"
                    (ngModelChange)="onSelectedCompanyChange($event)"
                    [options]="companiesArray"
                    optionLabel="label"
                    defaultLabel="Select Company"
                    filter="true"
                    [style]="{'width':'100%'}"
                    [disabled]="inProgress"
                ></p-dropdown>
              </div>
            </div>
            <div class="col-md-4" *ngIf="workersArray.length && showWorkers">
              <div class="form-group">
                <label>Worker</label>
                <p-dropdown
                    class="form-control"
                    [(ngModel)]="selectedWorker"
                    (ngModelChange)="onSelectedWorkerChange($event)"
                    [options]="workersArray"
                    optionLabel="label"
                    defaultLabel="Select Worker"
                    filter="true"
                    [style]="{'width':'100%'}"
                    [disabled]="inProgress"
                ></p-dropdown>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p-table [value]="workerSessions" selectionMode="single" [autoLayout]="true" [loading]="inProgress">
                <ng-template pTemplate="header">
                  <tr>
                    <th *ngIf="!selectedSite.value">Site</th>
                    <th *ngIf="!selectedWorker.value">Worker</th>
                    <th *ngIf="!selectedCompany.value">Company</th>
                    <th>Work Order ID</th>
                    <th>Work Order</th>
                    <th>Asset</th>
                    <th>Reason</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Site Session Id</th>
                    <th>Guests</th>
                    <th>Notes</th>
                    <th>Photos</th>
                    <th>Site Forms</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-workerSession>
                  <tr [pSelectableRow]="workerSession">
                    <td *ngIf="!selectedSite.value">{{workerSession.siteSession.site.name}}</td>
                    <td *ngIf="!selectedWorker.value">{{workerSession.user.firstName}} {{workerSession.user.lastName}}</td>
                    <td *ngIf="!selectedCompany.value">{{workerSession.user.workerUser.maintenance.name}}</td>
                    <!-- First WO handles a standard site session a company starts
                        Second WO field handles 'manager' sessions which don't have WOs -->
                    <ng-container *ngIf="workerSession.siteSession.workOrder !== null">
                      <td>{{workerSession.siteSession.workOrder.id}}</td>
                      <td>{{workerSession.siteSession.workOrder.description}}</td>
                    </ng-container>
                    <ng-container *ngIf="workerSession.siteSession.workOrder === null">
                      <td></td>
                      <td>
                        <span class="badge badge-pill badge-primary">Site Session</span>
                      </td>
                    </ng-container>
                    <!-- First Asset handles a standard WO which has an asset
                        Second Asset handles a manager visit, which has no asset -->
                    <td *ngIf="workerSession.siteSession.workOrder !== null">{{workerSession.siteSession.workOrder.asset.name}}</td>
                    <td *ngIf="workerSession.siteSession.workOrder === null">
                      N/A
                    </td>
                    <td>{{workerSession.reason}}</td>
                    <td>{{workerSession.startTime | date : 'E d MMM yyyy HH:mm'}}</td>
                    <!-- First End Time handles site session that has ended and has an end time
                        Second End Time handles a site session that is still open -->
                    <td *ngIf="workerSession.endTime !== null">{{workerSession.endTime | date : 'E d MMM yyyy HH:mm'}}</td>
                    <td *ngIf="workerSession.endTime === null">
                      <span class="badge badge-pill badge-success">Session open</span>
                    </td>
                    <td>{{workerSession.siteSession.id}}</td>
                    <td>{{workerSession.guestCount}}</td>
                    <td>
                      <a *ngIf="workerSession.notes !== null" href="javascript:void(0)" (click)="viewNotes(workerSession.notes)"><i class="fa fa-file" aria-hidden="true"></i></a>
                    </td>
                    <td>
                      <a *ngIf="workerSession.siteSession.uploadCount > 0" href="javascript:void(0)" (click)="viewPhotos(workerSession.id)"><i class="fa fa-images" aria-hidden="true"></i></a>
                    </td>
                    <td *ngIf="workerSession.siteFormResponseCount > 0">
                      <a href="javascript:void(0)" (click)="viewSiteForms(workerSession)">{{ workerSession.siteFormResponseCount }}</a>
                    </td>
                    <td *ngIf="workerSession.siteFormResponseCount === 0">0</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="13">
                      No worker sessions found
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator
            #paginator
            [rows]="pagination.size"
            [totalRecords]="pagination.totalRecords"
            [rowsPerPageOptions]="pageSizes"
            (onPageChange)="paginate($event)"
            [style.pointer-events]="inProgress ? 'none' : 'auto'"
            [style.opacity]="inProgress ? 0.6 : 1"
          ></p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
